import Autocomplete from '@mui/material/Autocomplete';
import { LegacyInput } from '../internal/LegacyInput';
import type { ColumnFilterProps } from '../types';
import { AutocompletePopperComponent } from './AutocompletePopperComponent';
import { useExternalOptions } from './ExternalFilterOptionsContext';

export const ExternalOptionColumnFilter = ({ column }: ColumnFilterProps) => {
  const options = useExternalOptions(column) ?? [];
  const value =
    options.find((option) => option.id === column.getFilterValue()) ?? null;

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(event, option) => {
        column.setFilterValue(option?.id);
      }}
      getOptionLabel={(option) => `${option.displayName} (${option.count})`}
      renderInput={(params) => (
        <LegacyInput {...params} margin="dense" placeholder="Filter..." />
      )}
      slots={{
        popper: AutocompletePopperComponent,
      }}
      size="small"
      sx={{ '& .MuiFilledInput-root': { paddingY: '3px' } }}
    />
  );
};
